import {Col, Form, Radio, Row} from "antd";
import {useEffect} from "react";
import {RADIO_BUTTON_VALUES} from "../../../util/Constants";
import {CustomerDto} from "../../../dto/CustomerDto";


interface OtherInformationProps {
    customerMstDto: CustomerDto
}


const OtherInformation = (props: OtherInformationProps) => {
    const [form] = Form.useForm();

    useEffect(() => {
        window.scrollTo(0, 0)
        let customerMstDto = props.customerMstDto;

        if (null != customerMstDto.greenCardHolderStatus && null != customerMstDto.politicallyExposedStatus) {
            let greenCardHolderStatus: string = customerMstDto.greenCardHolderStatus
            form.setFieldsValue(
                {
                    politicallyExposedStatus: customerMstDto.politicallyExposedStatus,
                    greenCardHolderStatus: greenCardHolderStatus
                }
            )
        } else {
            form.setFieldsValue(
                {
                    politicallyExposedStatus: null,
                    greenCardHolderStatus: null
                }
            )
        }


    }, [])

    return (
        <div>
            <Form
                className='form-input'
                layout={"vertical"}
                form={form}
                disabled={true}
            >
                <Row gutter={[32, 0]}>
                    <Col span={24}>
                        <Form.Item style={{marginBottom: 5}} className='other_info_select'
                                   label="U.S Permanent Resident" name={"greenCardHolderStatus"}>
                            <Radio.Group className='radio_group_set_view'>
                                <Radio value={RADIO_BUTTON_VALUES.YES}>Yes</Radio>
                                <Radio value={RADIO_BUTTON_VALUES.NO}>No</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>

                    <Col xxl={12} xl={12} lg={16} md={24} sm={24} xs={24} style={{marginTop: 8}}>
                        <Form.Item className='pep-form-item'
                                   label="Politically Exposed Status"
                                   name='politicallyExposedStatus'
                        >
                            <Radio.Group>
                                <Radio value={RADIO_BUTTON_VALUES.YES}>Yes</Radio>
                                <Radio value={RADIO_BUTTON_VALUES.NO}>No</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>

        </div>
    )
}
export default OtherInformation
